import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { listSupportTickets, createSupportTicket } from '../services/supportService';

export function useSupportTickets() {
  const { user, isAuthenticated } = useAuth();
  const [tickets, setTickets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!isAuthenticated || !user) {
      setTickets([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const data = await listSupportTickets();
      setTickets(data);
    } catch (err) {
      const msg = err.message || 'Failed to load support tickets';
      if (/support_tickets/i.test(msg) && /does not exist|schema cache/i.test(msg)) {
        setError(
          'Support tickets table not found. Run database/migrations/006_create_support_tickets.sql in the Supabase SQL editor.'
        );
      } else {
        setError(msg);
      }
    } finally {
      setIsLoading(false);
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const create = useCallback(async (payload) => {
    const ticket = await createSupportTicket(payload);
    setTickets((prev) => [ticket, ...prev]);
    return ticket;
  }, []);

  return { tickets, isLoading, error, refetch, create };
}
